import Vue from 'vue'
import Vuex from 'vuex'
import { getDefaultFilters } from '@/utils/livableCityDefaults'
import { fetchLivableCityData } from '@/services/livableCityService'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				homeRecommand: [1, 2, 3],
				homeRecommandPC: [3],
				listRecommand: [1, 2, 3],
				listRecommandPC: [3],
			},
			adsensConfig: {},

			domainConfig: {
				siteName: 'SITE_NAME',
				siteIcon: '/icon/1.svg',
				IAMEMAIL: 'CONTACT_EMAIL',
				meta: {
					title: 'META_TITLE_SUFFIX',
					des: 'META_DEFAULT_DESCRIPTION',
				},
				contentText: {},
				firebase: {
					apiKey: 'AIzaSyBal6oqqvB2XIcHHfP3epuvS3GMrr9dhYs',
					authDomain: 'web-pub-3195-1.firebaseapp.com',
					projectId: 'web-pub-3195-1',
					storageBucket: 'web-pub-3195-1.firebasestorage.app',
					messagingSenderId: '716333800842',
					appId: '1:716333800842:web:520c1a590786c483f03c73',
					measurementId: 'G-6HEWZB4XVR',
				},
				ads: 'success',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9524345982013195',
				},
			},
			glossary: [],
			subprimeLendingInstitutions: [],
			livableCityData: {
				cities: [],
				blogs: [],
				quotes: [],
				regionOptions: [],
				standardOptions: [],
				topStandardValue: {},
			},
			livableCityFilters: getDefaultFilters(),
			livableCitySortHighToLow: true,
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setGlossary(state, glossary) {
				state.glossary = glossary
			},
			setSubprimeLendingInstitutions(state, subprimeLendingInstitutions) {
				state.subprimeLendingInstitutions = subprimeLendingInstitutions
			},
			setLivableCityData(state, payload) {
				state.livableCityData = payload
			},
			setLivableCityFilters(state, filters) {
				state.livableCityFilters = {
					...state.livableCityFilters,
					...filters,
				}
			},
			setLivableCitySort(state, isHighToLow) {
				state.livableCitySortHighToLow = isHighToLow
			},
			resetLivableCityFilters(state) {
				state.livableCityFilters = getDefaultFilters()
			},
		},
		actions: {
			async initLivableCityData({ state, commit }) {
				if (state.livableCityData.cities.length) {
					return
				}
				const payload = await fetchLivableCityData()
				commit('setLivableCityData', payload)
				commit('resetLivableCityFilters')
				commit('setLivableCitySort', true)
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			glossary: (state) => state.glossary,
			subprimeLendingInstitutions: (state) => state.subprimeLendingInstitutions,
			livableCityData: (state) => state.livableCityData,
			livableCityFilters: (state) => state.livableCityFilters,
			livableCitySortHighToLow: (state) => state.livableCitySortHighToLow,
			filteredCitiesRaw: (state) => {
				const { cities, topStandardValue } = state.livableCityData
				const { regions, standards } = state.livableCityFilters
				const filtered = cities.filter((city) => {
					const inRegion = regions.includes(city.region)
					if (!inRegion) {
						return false
					}
					if (!standards.length) {
						return true
					}
					return standards.every((key) => city.metrics[key] === topStandardValue[key])
				})
				return filtered.sort((a, b) =>
					state.livableCitySortHighToLow ? b.score - a.score : a.score - b.score,
				)
			},
			filteredCities: (state, getters) => getters.filteredCitiesRaw,
			filteredCityCount: (state, getters) => getters.filteredCitiesRaw.length,
		},
	})
}
